export default (config) => {
    const token = sessionStorage.getItem('token');
    const tenant = sessionStorage.getItem('tenant');

    config.headers.Authorization =  token ? `Bearer ${token}` : '';
    config.headers.ServiceIdentify = tenant ? tenant : '';
    
    return config;
};